import { w as C } from "../withTheme-zx3wTAWo.es.js";
import t from "react";
import o from "prop-types";
import b from "classnames";
import { u as w } from "../utils-C0l876fA.es.js";
import { S as x } from "../ShimmerBlock-hNiBn9_0.es.js";
import { T as n } from "../index-Dd-4N6BE.es.js";
import { I as k } from "../Icon-BuIPTPJn.es.js";
import { N as p } from "../NoClickOutline-CllwvnB9.es.js";
import '../index11.css';const y = "#000", A = "#fff", E = "20", M = "#026fd9", S = "Chip-default-module__text___PGaaJ", T = "Chip-default-module__closeButton___QP3Xw", N = "Chip-default-module__hover___QtxeX", B = "Chip-default-module__icon___kJtGs", D = "Chip-default-module__button___3SlvD", a = {
  black: y,
  white: A,
  iconSize: E,
  linkColor: M,
  text: S,
  "chip-placeholder": "Chip-default-module__chip-placeholder___x9hnX",
  closeButton: T,
  hover: N,
  icon: B,
  "container-controls": "Chip-default-module__container-controls___mQ0Dm",
  button: D,
  "measure-mode-outer": "Chip-default-module__measure-mode-outer___J7r7M",
  "measure-mode-inner": "Chip-default-module__measure-mode-inner___Luqq-",
  "chip-gray": "Chip-default-module__chip-gray___PNYXC",
  "chip-light-gray": "Chip-default-module__chip-light-gray___1rYnb",
  "chip-blue": "Chip-default-module__chip-blue___J3thQ",
  "chip-gold": "Chip-default-module__chip-gold___MOCKA",
  "chip-green": "Chip-default-module__chip-green___KHhle",
  "chip-mint": "Chip-default-module__chip-mint___gwmKy",
  "chip-purple": "Chip-default-module__chip-purple___MdUjM",
  "chip-lavender": "Chip-default-module__chip-lavender___QnNmc"
}, $ = "#000", z = "#fff", O = "20", P = "#0050dc", R = "Chip-compere-module__text___bAAT4", Q = "Chip-compere-module__closeButton___xdMVa", L = "Chip-compere-module__hover___QlyXk", F = "Chip-compere-module__icon___tEO42", q = "Chip-compere-module__button___cyZ6U", f = {
  black: $,
  white: z,
  iconSize: O,
  linkColor: P,
  text: R,
  "chip-placeholder": "Chip-compere-module__chip-placeholder___av-OR",
  closeButton: Q,
  hover: L,
  icon: F,
  "container-controls": "Chip-compere-module__container-controls___Q-r5N",
  button: q,
  "measure-mode-outer": "Chip-compere-module__measure-mode-outer___zwDAM",
  "measure-mode-inner": "Chip-compere-module__measure-mode-inner___vTNAm",
  "chip-gray": "Chip-compere-module__chip-gray___6PwSW",
  "chip-light-gray": "Chip-compere-module__chip-light-gray___j-gex",
  "chip-blue": "Chip-compere-module__chip-blue___9XDTk",
  "chip-deep-purple": "Chip-compere-module__chip-deep-purple___inQCJ",
  "chip-gold": "Chip-compere-module__chip-gold___uxVLd",
  "chip-green": "Chip-compere-module__chip-green___kdIVa",
  "chip-pink": "Chip-compere-module__chip-pink___CCQIH",
  "chip-purple": "Chip-compere-module__chip-purple___TOHHo"
}, g = {
  default: a,
  compere: f
}, c = {
  default: [
    "blue",
    "gold",
    "green",
    "light-gray",
    "lavender",
    "mint",
    "purple",
    "gray"
  ],
  compere: [
    "blue",
    "deep-purple",
    "gold",
    "green",
    "light-gray",
    "pink",
    "purple",
    "gray"
  ]
};
class h extends t.Component {
  constructor(e) {
    super(e), this.state = { hover: !1 };
  }
  render() {
    const e = g[this.props.theme] || a, r = c[this.props.theme] || c.default;
    let l = this.props.color;
    r.includes(l) || (l = "blue");
    const i = `chip-${l}`;
    return /* @__PURE__ */ t.createElement("div", { className: e[i], role: "listitem" }, /* @__PURE__ */ t.createElement(n.Body3, { theme: this.props.theme, responsive: !0, tagName: "span" }, /* @__PURE__ */ t.createElement("span", { className: e.text }, this.props.label)), this.props.onDelete && /* @__PURE__ */ t.createElement(
      p.Button,
      {
        className: b(
          e.closeButton,
          this.state.hover && e.hover
        ),
        onClick: this.props.onDelete,
        onMouseOver: () => this.setState({ hover: !0 }),
        onMouseOut: () => this.setState({ hover: !1 }),
        "aria-label": `Remove ${this.props.label}`
      },
      /* @__PURE__ */ t.createElement(
        k,
        {
          name: "close",
          className: e.icon,
          size: parseInt(e.iconSize, 10),
          color: this.state.hover ? e.white : e.black
        }
      )
    ));
  }
}
h.propTypes = {
  /** The color of the chip. 'deep-purple' and 'pink' are Compere theme only, 'lavender' and 'mint' are default theme only.
   * If an invalid color/theme combination is provided, defaults to 'blue'
   * */
  color: o.oneOf([...c.compere, ...c.default]),
  /** The text appearing in the Chip */
  label: o.node.isRequired,
  /** The callback when the close button is clicked. Chip will be non-interactive if this is omitted. */
  onDelete: o.func,
  /** The theme of the chip */
  theme: o.oneOf(["default", "compere"]).isRequired
};
h.defaultProps = {
  color: "blue",
  onDelete: null
};
const I = () => {
  const { t: m } = w();
  return /* @__PURE__ */ t.createElement("span", { "aria-label": m("loading") }, /* @__PURE__ */ t.createElement(
    x,
    {
      className: g.default["chip-placeholder"]
    }
  ));
};
h.Placeholder = I;
const d = C(h), X = {
  default: a,
  compere: f
};
let u = class extends t.Component {
  state = {
    numChips: 0,
    measureMode: !0,
    expanded: !1,
    lastAction: void 0
  };
  componentDidMount() {
    this.timeout = setTimeout(() => {
      this.checkSize();
    }, 10), window.addEventListener("resize", this.measureAgain);
  }
  componentDidUpdate(e) {
    e.chips.length !== this.props.chips.length && this.measureAgain(), this.checkSize();
  }
  componentWillUnmount() {
    clearTimeout(this.timeout), window.removeEventListener("resize", this.measureAgain);
  }
  chipSpace = t.createRef();
  allSpace = t.createRef();
  checkSize = () => this.setState((e) => {
    if (!e.measureMode || !this.chipSpace.current || !this.allSpace.current)
      return null;
    const r = this.chipSpace.current.getBoundingClientRect().width, l = this.allSpace.current.getBoundingClientRect().width, i = r >= l;
    return e.expanded ? {
      numChips: this.props.chips.length,
      measureMode: !1,
      expanded: i
    } : i && e.lastAction === "added" ? {
      numChips: e.numChips - 1,
      lastAction: "removed",
      measureMode: !1
    } : i && e.numChips === 0 ? {
      measureMode: !1
    } : i ? {
      numChips: e.numChips - 1,
      lastAction: "removed"
    } : e.numChips < this.props.chips.length ? {
      numChips: e.numChips + 1,
      lastAction: "added"
    } : {
      measureMode: !1
    };
  });
  measureAgain = () => {
    this.setState({ measureMode: !0, lastAction: void 0 });
  };
  resetChips = () => {
    this.setState({
      numChips: 0,
      measureMode: !0,
      expanded: !1,
      // eslint-disable-next-line react/no-unused-state
      lastAction: void 0
    });
  };
  interpolateShowMoreText = () => this.props.showMoreText.replace(
    "{num_hidden}",
    this.props.chips.length - this.state.numChips
  );
  render() {
    const e = X[this.props.theme] || a, r = !!this.props.clearAllText && !!this.props.onClearAll && this.props.chips.length > 0 && /* @__PURE__ */ t.createElement(
      p.Button,
      {
        className: e.button,
        onClick: this.props.onClearAll
      },
      /* @__PURE__ */ t.createElement(
        n.Link,
        {
          theme: this.props.theme,
          color: e.linkColor,
          responsive: !0
        },
        /* @__PURE__ */ t.createElement("i", null, this.props.clearAllText)
      )
    ), l = this.state.numChips < this.props.chips.length && /* @__PURE__ */ t.createElement(
      p.Button,
      {
        className: e.button,
        onClick: () => this.setState({
          numChips: this.props.chips.length,
          expanded: !0
        })
      },
      /* @__PURE__ */ t.createElement(
        n.Link,
        {
          theme: this.props.theme,
          color: e.linkColor,
          responsive: !0
        },
        /* @__PURE__ */ t.createElement("i", null, this.interpolateShowMoreText())
      )
    ), i = this.state.expanded && /* @__PURE__ */ t.createElement(
      p.Button,
      {
        className: e.button,
        onClick: this.resetChips
      },
      /* @__PURE__ */ t.createElement(
        n.Link,
        {
          theme: this.props.theme,
          color: e.linkColor,
          responsive: !0
        },
        /* @__PURE__ */ t.createElement("i", null, this.props.showFewerText)
      )
    ), _ = this.props.chips.slice(0, this.state.numChips).map(
      (s, v) => s ? /* @__PURE__ */ t.createElement(
        d,
        {
          color: s.color,
          key: s.label,
          label: s.label,
          onDelete: s.onDelete,
          theme: this.props.theme
        }
      ) : (
        // eslint-disable-next-line react/no-array-index-key
        /* @__PURE__ */ t.createElement(d.Placeholder, { key: v })
      )
    );
    return this.state.measureMode ? /* @__PURE__ */ t.createElement(
      "div",
      {
        className: e["measure-mode-outer"],
        ref: this.allSpace
      },
      /* @__PURE__ */ t.createElement(
        "div",
        {
          className: e["measure-mode-inner"],
          ref: this.chipSpace,
          role: "group",
          "aria-live": "polite"
        },
        _,
        /* @__PURE__ */ t.createElement("div", { className: e["container-controls"] }, l, r)
      )
    ) : /* @__PURE__ */ t.createElement("div", { role: "group", "aria-live": "polite" }, _, /* @__PURE__ */ t.createElement("div", { className: e["container-controls"] }, l, i, r));
  }
};
u.propTypes = {
  /** Props for the chips to be rendered. For possible color options, see [Chip](/?path=/docs/2-components-chip--chip-demo)   */
  chips: o.arrayOf(
    o.shape({
      color: o.string,
      label: o.string.isRequired,
      onDelete: o.func
    })
  ).isRequired,
  /** label for the button which clears all filter chips. If the empty string, the button will not be rendered */
  clearAllText: o.string,
  /** function to be called when the button labeled by "clearAllText" is clicked. If falsy the button will not be rendered */
  onClearAll: o.func,
  /** label for the button which displays all filter chips.
   * Can include '{num_hidden}' which will be replaced by the number of chips that will be revealed on clicking
   */
  showMoreText: o.string,
  /** label for the button which collapses to only display one line of chips */
  showFewerText: o.string,
  /** Supports the cross-Mintel design (default), and the Compere design */
  theme: o.oneOf(["default", "compere"])
};
u.defaultProps = {
  clearAllText: "Clear All",
  onClearAll: null,
  showMoreText: "Show More Filter Chips",
  showFewerText: "Show Fewer Filter Chips",
  theme: "default"
};
const ee = C(u);
export {
  ee as ChipContainer,
  d as default
};
